import { render, staticRenderFns } from "./adderss-list.vue?vue&type=template&id=2d365d67&scoped=true&"
import script from "./adderss-list.vue?vue&type=script&lang=js&"
export * from "./adderss-list.vue?vue&type=script&lang=js&"
import style0 from "./adderss-list.vue?vue&type=style&index=0&id=2d365d67&prod&lang=scss&"
import style1 from "./adderss-list.vue?vue&type=style&index=1&id=2d365d67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d365d67",
  null
  
)

export default component.exports